(function activitiDefinition() {
    'use strict';
    angular.module('Entities')
        .service('activitiService', [
            'restUrlBuilder', 'authExtend', function activitiService(restUrlBuilder, auth) {

                var activitiFilter = {};


                this.get = function get() {
                    var params;


                    params = {
                        OrganizationalUnitId: desc.organizationalUnitId,
                        UserId: desc.userId,
                        ActionType: undefined,
                        DateFrom: desc.dateFrom,
                        DateTo: desc.dateTo,
                        Page: desc.page,
                        ItemPerPage: desc.itemPerPage,
                        UserName: desc.nickName
                    };

                    if (desc.actionType) {
                        params.ActionType = desc.actionType.id;
                    }


                    return restUrlBuilder.all('WorkFlow')
                        .get({ params: params });
                };

                this.getProcesses = function getTypes() {
                    return restUrlBuilder.all('WorkFlow')
                        .get();
                };

                this.getById = function getById(id) {
                    return restUrlBuilder.one('activiti', id).get();
                };

                this.iniciarInstanciaProceso = function iniciarInstanciaProceso(selectedProcess) {
                    return restUrlBuilder.all('WorkFlow/StartProcessInstance').post(selectedProcess);
                };

                this.claimTask = function claimTask(selectedTask) {

                    var request = { "action": "claim", "assignee": "kermit", "taskId": selectedTask.id}

                    return restUrlBuilder.all('WorkFlow/TaskAction').post(request);
                };

                this.aprobar = function aprobar(selectedTask, aprobado) {

                    var request = { "action": "complete", "variables": [{ "name": "vacationApproved", "value": aprobado }, { "name": "managerMotivation", "value": "que se joda" }], "taskId": selectedTask.id}

                    return restUrlBuilder.all('WorkFlow/TaskAction').post(request);
                };

                this.getAllProcessesInstances = function getTypes() {
                    return restUrlBuilder.all('WorkFlow/GetAllProcessInstance')
                        .get();
                };

                this.getUserProcessTasks = function getTypes() {
                    return restUrlBuilder.all('WorkFlow/GetUserProcInstance')
                        .get();
                };                

            }
        ]);
})();